import { useEffect, useRef, useState } from 'react'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Link as Scroll } from 'react-scroll'
import { Link } from 'react-router-dom'

import Info from './information'
import { classes, ViewerUnitStyle } from './style'
import Viewer from '../../components/useViewer'
import IconButton from '@mui/material/IconButton'
import Apartment from '@mui/icons-material/Apartment'
import Splitscreen from '@mui/icons-material/Splitscreen'
import Villa from '@mui/icons-material/Villa'
import ToolBar from '../../components/toolBar'
import { setUnitTypeScreen } from '../../actions/viewerActions'
import { useDispatch, useSelector } from 'react-redux'
import clsx from 'clsx'
import Loading from '../../components/loading'

const UnitView = () => {
  const mountRef = useRef(null)
  const [top] = useState(false)
  const dispatch = useDispatch()
  const type = useSelector(state => state.viewer.unitTypeScreen)
  const loading = useSelector(state => state.viewer.loading)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  useEffect(() => {
    const containerCanvas = document.getElementById('unitId')
    // var gui = new GUI();
    const scene = new THREE.Scene()
    const camera = new THREE.PerspectiveCamera(75, containerCanvas.clientWidth / containerCanvas.clientHeight, 1, 5000)

    const renderer = new THREE.WebGLRenderer({ alpha: true })
    renderer.shadowMapEnabled = true
    renderer.shadowMap.type = THREE.PCFSoftShadowMap
    renderer.setClearColor(0x000000, 0)

    renderer.setSize(containerCanvas.clientWidth, containerCanvas.clientHeight)

    const controls = new OrbitControls(camera, renderer.domElement)
    // controls.screenSpacePanning = true;
    controls.update()
    controls.enablePan = false

    mountRef.current.appendChild(renderer.domElement)

    // trackControls.addEventListener('change', render);

    //* ************+lights*************
    const light = new THREE.AmbientLight(0xffffff, 0.8) // soft white light
    scene.add(light)

    const spotLight = new THREE.SpotLight(0xffffff, 1)

    // spotLight.position.set( -10, 7, 6.6 );
    spotLight.position.set(2, 50, 0)
    spotLight.castShadow = true
    spotLight.angle = 0.4
    spotLight.penumbra = 0.05
    spotLight.decay = 1
    spotLight.distance = 2000

    const shadowMapSize = 32
    spotLight.shadow.mapSize.width = shadowMapSize
    spotLight.shadow.mapSize.height = shadowMapSize

    spotLight.shadow.camera.near = 1.0
    spotLight.shadow.camera.far = 300
    spotLight.shadow.bias = 0.0001

    const boxSize = 1000
    spotLight.shadow.camera.left = -boxSize
    spotLight.shadow.camera.bottom = -boxSize

    spotLight.shadow.camera.right = boxSize
    spotLight.shadow.camera.top = boxSize

    // spotLight.shadow.radius = 8;

    spotLight.shadowCameraVisible = true

    scene.add(spotLight)

    // spotLight.target.position.set( 3, 0, - 3 );
    // scene.add( spotLight.target );

    // eslint-disable-next-line no-unused-vars
    const data = {
      color: spotLight.color.getHex(),
      mapsEnabled: true,
      shadowMapSizeWidth: shadowMapSize,
      shadowMapSizeHeight: shadowMapSize,

      shadowCameraLeft: -boxSize,
      shadowCameraBottom: -boxSize,
      shadowCameraRight: boxSize,
      shadowCameraTop: boxSize,
      positionX: 0
    }

    // const helper = new THREE.SpotLightHelper(spotLight)

    // scene.add(helper)
    const light2 = new THREE.DirectionalLight(0xffffff)
    light2.position.set(10, 50, 0)
    // light2.castShadow = true;
    light2.shadow.camera.left = -100
    light2.shadow.camera.right = 100
    light2.shadow.camera.top = 100
    light2.shadow.camera.bottom = -100
    scene.add(light2)

    const geometry = new THREE.PlaneGeometry(30, 30, 8, 8)
    const material = new THREE.ShadowMaterial()
    material.opacity = 0.2
    const floor = new THREE.Mesh(geometry, material)
    floor.rotateX(-Math.PI / 2)
    floor.receiveShadow = true
    scene.add(floor)

    const loader = new GLTFLoader()
    loader.load(

      // `${process.env.PUBLIC_URL}/3dmodels/scene1.glb` ,
            `${process.env.PUBLIC_URL}/3dmodels/gltf/model.glb`,
            function (gltf) {
              gltf.scene.traverse(function (node) {
                if (node.isMesh) {
                  node.castShadow = true
                  node.receiveShadow = true
                }
              })
              gltf.scene.scale.set(1, 1, 1)
              gltf.scene.position.set(0, 0.2, 0)
              scene.add(gltf.scene)

              setTimeout(() => {
                animateCameraStarting()
              })
            },
            (xhr) => {
              console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
            },
            (error) => {
              console.log(error)
            }
    )

    camera.position.x = 0
    camera.position.z = 250
    camera.position.y = 500

    const positionTween = new TWEEN.Tween(camera.position)
      .easing(TWEEN.Easing.Quadratic.InOut)
    const rotationTween = new TWEEN.Tween(camera.rotation)
      .easing(TWEEN.Easing.Quadratic.InOut)

    const buttonCameraSettings = {
      button1: {
        position: { x: 100, y: 100, z: 100 },
        rotation: { x: 100, y: -Math.PI, z: 100 }
      },
      button2: {

        position: { x: 0, y: 8, z: 9 },
        rotation: { x: 0, y: Math.PI, z: 0 }
      }
    }

    function updateCameraTweens (params) {
      if (params.position) {
        positionTween.stop()
        positionTween.to(params.position, 1000).start()
      }

      if (params.rotation) {
        rotationTween.stop()
        rotationTween.to(params.rotation, 1000).start()
      }
    }

    const animateScrollTop = function () {
      const cameraSettings = buttonCameraSettings.button2
      updateCameraTweens(cameraSettings)
    }

    const animateScrollBottom = function () {
      const cameraSettings = buttonCameraSettings.button1

      updateCameraTweens(cameraSettings)
      /*
            const positionStart = {
                x : camera.position.x,

            };
            const  positionEnd = {
                x : 0,
            };
            var tween = new TWEEN.Tween(positionStart)
                .to(positionEnd , 1000)
            tween.easing(TWEEN.Easing.Circular.InOut)

            tween.onUpdate(function() {
                camera.position.x =   positionEnd.x

            });

            tween.start();

             */
    }

    const positionStart = {
      x: 100,
      y: 100,
      z: 100

    }
    const positionEnd = {
      x: 0,
      y: 8,
      z: 9
    }

    const animateCameraStarting = function () {
      const tween = new TWEEN.Tween(positionStart)
        .to(positionEnd, 2000)
      tween.easing(TWEEN.Easing.Circular.InOut)

      tween.onUpdate(function () {
        console.log('update upper')
        camera.position.x = positionStart.x
        camera.position.y = positionStart.y
        camera.position.z = positionStart.z
      })

      tween.start()
    }

    /*
        var cam = gui.addFolder('Camera');

        cam.add(camera.position, 'x', 0, 100).listen();
        cam.add(camera.position, 'y', 0, 100).listen();
        cam.add(camera.position, 'z', 0, 100).listen();
        cam.open();

 */

    const animate = function () {
      requestAnimationFrame(animate)
      // cube.rotation.x += 0.01;
      // cube.rotation.y += 0.01;

      TWEEN.update()
      controls.update()
      renderer.render(scene, camera)
    }

    const onWindowResize = function () {
      camera.aspect = containerCanvas.clientWidth / containerCanvas.clientHeight
      camera.updateProjectionMatrix()
      renderer.setSize(containerCanvas.clientWidth, containerCanvas.clientHeight)
    }

    const _debounce = function (ms, fn) {
      let timer
      return function () {
        clearTimeout(timer)
        const args = Array.prototype.slice.call(arguments)
        args.unshift(this)
        timer = setTimeout(fn.bind.apply(fn, args), ms)
      }
    }

    const observer = new ResizeObserver(
      _debounce(100, () => {
        onWindowResize()
      })
    )
    if (mountRef.current) {
      observer.observe(mountRef.current)
    }

    window.addEventListener('resize', onWindowResize, false)

    // eslint-disable-next-line no-unused-vars
    function moveCam () {
      console.log('---- move')
      const pos1 = new TWEEN.Tween(camera.position).to({
        y: 300
      }, 3000).easing(TWEEN.Easing.Quadratic.InOut)

      const pos2 = new TWEEN.Tween(camera.position).to({
        x: -400
      }, 4000).easing(TWEEN.Easing.Quadratic.InOut)

      const pos3 = new TWEEN.Tween(camera.position).to({
        y: -10
      }, 4000).easing(TWEEN.Easing.Quadratic.InOut)

      const rot1 = new TWEEN.Tween(camera.rotation).to({
        y: -1
      }, 4000).easing(TWEEN.Easing.Quadratic.InOut)

      const pos4 = new TWEEN.Tween(camera.position).to({
        x: 600
      }, 6000).easing(TWEEN.Easing.Quadratic.InOut)

      const pos5 = new TWEEN.Tween(camera.position).to({
        y: -400
      }, 2000).easing(TWEEN.Easing.Quadratic.InOut)

      const rot2 = new TWEEN.Tween(camera.rotation).to({
        y: -5
      }, 2000).easing(TWEEN.Easing.Quadratic.InOut)

      const pos6 = new TWEEN.Tween(camera.position).to({
        z: 10
      }, 5000).easing(TWEEN.Easing.Quadratic.InOut)

      const rot3 = new TWEEN.Tween(camera.rotation).to({
        y: 0
      }, 2000).easing(TWEEN.Easing.Quadratic.InOut)

      pos1.start()
      pos1.chain(pos2)
      pos2.chain(pos3, rot1)
      rot1.chain(pos4)
      pos4.chain(pos5, rot2)
      rot2.chain(pos6)
      pos6.chain(rot3)
    }

    const button2 = document.getElementById('button2')
    button2.addEventListener('click', function (ev) {
      animateScrollTop()
      // animateCameraStarting()
    })

    const button1 = document.getElementById('button1')
    button1.addEventListener('click', function (ev) {
      animateScrollBottom()
    })

    animate()

    return () => {
      mountRef.current && mountRef.current.removeChild(renderer.domElement)
      mountRef.current && observer.unobserve(mountRef.current)
    }
  }, [])

  const scrollTop = () => {
    // setTop(true)
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 200)
  }

  const onCallbackClick = () => {
    console.log('building clicked')
  }

  return (
        <div>
          <Loading open={loading} type="circular"/>
            <ViewerUnitStyle className={classes.root} id="3dContainer" >
              <ToolBar>
                <IconButton

                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  sx={{ ml: 1 }}
                  style={{ color: 'gray' }}
                  className={clsx({ [classes.activeIcon]: type === 'building' })}
                  onClick={() => {
                    dispatch(setUnitTypeScreen('building'))

                    setTimeout(() => {
                      window.useViewer.mapResize()
                    }, 100)
                  }}
                >
                  <Apartment/>

                </IconButton>
                <IconButton
                  color="inherit"
                  sx={{ ml: 1 }}
                  style={{ color: 'gray', transform: ' rotate(90deg)' }}
                  className={clsx({ [classes.activeIcon]: type === 'split' })}
                  onClick={() => {
                    dispatch(setUnitTypeScreen('split'))
                    setTimeout(() => {
                      window.useViewer.mapResize()
                    }, 100)
                  }}
                >
                  <Splitscreen />
                </IconButton>
                <IconButton
                  color="inherit"
                  sx={{ ml: 1 }}
                  style={{ color: 'gray' }}
                  className={clsx({ [classes.activeIcon]: type === 'unit' })}
                  onClick={() => {
                    dispatch(setUnitTypeScreen('unit'))
                    setTimeout(() => {
                      window.useViewer.mapResize()
                    }, 100)
                  }}
                >
                  <Villa />
                </IconButton>
              </ToolBar>
                <Scroll to="info" spy={true} smooth={true} duration={500}>
                    <button className={classes.btnDown} id="button1">
                      <ArrowDownwardIcon/>
                      More Details
                    </button>
                </Scroll>
                <Link className={classes.btnLeft} to={'/search'} style={{ textDecoration: 'none' }}>
                  <ArrowBackIcon/>
                  Back to Units
                </Link>

              <div style={{ display: 'flex' }}>
                <div className={clsx({
                  [classes.screen]: true,
                  [classes.middleScreen]: type === 'split',
                  [classes.fullScreen]: type === 'building',
                  [classes.hiddenScreen]: type === 'unit'
                })}>
                  <Viewer onCallbackClick={onCallbackClick}/>
                </div>
                <div ref={mountRef} id="unitId" className={clsx({
                  [classes.screen]: true,
                  [classes.middleScreen]: type === 'split',
                  [classes.fullScreen]: type === 'unit',
                  [classes.hiddenScreen]: type === 'building'
                })}></div>
              </div>
            </ViewerUnitStyle>
            <Info callbackClick={scrollTop} top={top}/>
        </div>
  )
}

export default UnitView
